module.exports = __webpack_public_path__ + "img/icon-radio-active-survey.ee2c9cfc.svg";